import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setDrawerOpen(false);
  };

  const menuItems = [
    { text: "Isabela & Tiago", id: "home" },
    { text: "Alojamento & Transporte", id: "travel" },
    { text: "Lista de Presentes", id: "registry" },
    { text: "Confirmar Presença", id: "rsvp" },
  ];

  return (
    <>
      <AppBar
        component={motion.header}
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        position="fixed"
        sx={{
          backgroundColor: "#faf4e9",
          boxShadow: "0 1px 3px rgba(26,58,82,0.03)",
          borderBottom: "1px solid rgba(26,58,82,0.02)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "center",
            position: "relative",
            minHeight: { xs: "64px" },
            px: 2,
          }}
        >
          <IconButton
            edge="end"
            aria-label={drawerOpen ? "close menu" : "open menu"}
            onClick={() => setDrawerOpen(!drawerOpen)}
            sx={{
              position: "absolute",
              right: 16,
              color: "#1a3a52",
              "&:hover": {
                backgroundColor: "rgba(26,58,82,0.04)",
              },
            }}
          >
            {drawerOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>

          <Typography
            variant="h6"
            component="a"
            href="https://forms.gle/ZDjQNBD6uA3DNEHs9"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              mr: { xs: 2, sm: 0 },
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: 400,
              fontSize: { xs: "0.75rem", sm: "1rem", md: "1.25rem" },
              color: "#1a3a52",
              letterSpacing: "0.5px",
              textAlign: "center",
              cursor: "pointer",
              textDecoration: "none",
              "&:hover": {
                opacity: 0.8,
              },
            }}
          >
            Confirmar presença até dia 4 de maio de 2026
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        elevation={0}
        sx={{
          "& .MuiDrawer-paper": {
            width: 280,
            backgroundColor: "#faf4e9",
            pt: 8,
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
          }}
        >
          <List sx={{ px: 2 }}>
            {menuItems.map((item) => (
              <ListItem key={item.id} disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                  onClick={() => scrollToSection(item.id)}
                  sx={{
                    borderRadius: 1,
                    py: 1.5,
                    "&:hover": {
                      backgroundColor: "rgba(26,58,82,0.04)",
                    },
                  }}
                >
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: "0.95rem",
                      fontWeight: 400,
                      color: "#1a3a52",
                      letterSpacing: "0.3px",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default Header;
